import styled, { css } from 'styled-components';
import { spin } from '../../../../utils/style';
import { BaseStyledComponentProps, NewStyleColor } from '../../../../utils/styles-constants';
import { ParametersPageButton } from '../../../ParametersPage/styles';

interface StyledUpdateFolderTreeButtonProps extends BaseStyledComponentProps {
	isUpdating?: boolean;
	isOffline?: boolean;
}
const StyledUpdateFolderTreeButton = styled(ParametersPageButton)`
	color: ${(props: StyledUpdateFolderTreeButtonProps) =>
		props.isOffline ? NewStyleColor.Grey500 : props.theme.primary.strongColor};

	&:disabled {
		cursor: not-allowed;
		opacity: ${(props: StyledUpdateFolderTreeButtonProps) => props.isOffline ? 0.5 : 0.6};
	}

	& > svg {
		position: relative;
		left: 5px;
		height: 25px;
		width: 25px;

		${(p: StyledUpdateFolderTreeButtonProps) => p.isUpdating && css`
			animation: ${spin};
		`}
	}

	${(p: StyledUpdateFolderTreeButtonProps) => p.isUpdating && `
	& > span {
		margin-left: 15px;
	}`}
`;

export { StyledUpdateFolderTreeButton };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/ActionButtons/UpdateFolderTreeButton/styles.ts